let loading;
function loadMaps(key) {
    if (window.google?.maps?.Map) return Promise.resolve(window.google.maps);
    if (!loading) loading = new Promise((resolve, reject) => {
        if (!key) { reject(new Error('Map unavailable')); return; }
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}`;
        script.async = true;
        script.onload = () => window.google?.maps?.Map ? resolve(window.google.maps) : reject(new Error('Map unavailable'));
        script.onerror = reject;
        document.head.appendChild(script);
    });
    return loading;
}
export function initLocationMap(root, state, config) {
    const element = root.querySelector('[data-chalet-map]');
    if (!element || !config.center) return;
    let initialized = false;
    state.subscribe(async ({activeTab}) => {
        if (activeTab !== 'location' || initialized) return;
        initialized = true;
        try {
            const maps = await loadMaps(config.key);
            const map = new maps.Map(element, {center: config.center, zoom: 13, mapTypeId: 'roadmap'});
            const info = new maps.InfoWindow();
            config.markers.forEach((location, index) => {
                const marker = new maps.Marker({map, position: location.position, icon: location.icon || undefined, title: location.name});
                marker.addListener('click', () => {
                    const template = root.querySelector(`[data-chalet-marker="${index}"]`);
                    info.setContent(template.content.firstElementChild.cloneNode(true));
                    info.open(map, marker);
                });
            });
        } catch (_) {
            element.textContent = 'The map is currently unavailable.';
        }
    });
}
